// PRD §3.3 + §M2 — multi-animal event batch schemas (vet vacuna a 30+ animais).
import { z } from 'zod';
import { eventDataSchemas } from './event.zod.js';
const EventTypeEnum = z.enum(Object.keys(eventDataSchemas));
export const CreateEventBatchRequestSchema = z
    .object({
    type: EventTypeEnum,
    data_json: z.unknown(),
    // Phase 25 iter-25 (Lote P-3, B10) — cap lowered 500 → 200. Realistic
    // upper bound for a single vet act (a full herd of mid-sized farms is
    // ~150-200 animals); the 500 cap was a paranoid back-of-envelope. The
    // hard ceiling protects the backend handler from a single client
    // dispatching N=10000 by accident or malice.
    animal_ids: z.array(z.string().uuid()).min(1).max(200),
    timestamp: z.string().datetime({ offset: true }).optional(),
    gps_lat: z.number().min(-90).max(90).nullable().optional(),
    gps_lng: z.number().min(-180).max(180).nullable().optional(),
    /** Single ECDSA P-256 sig over the canonical batch payload. */
    vet_signature: z.string().min(16).max(1024).optional(),
})
    .strict();
export const EventBatchResponseSchema = z.object({
    id: z.string().uuid(),
    vet_id: z.string().uuid().nullable(),
    type: EventTypeEnum,
    timestamp: z.string().datetime({ offset: true }),
    events_count: z.number().int().nonnegative(),
    vet_signature: z.string().nullable(),
});
//# sourceMappingURL=event-batch.js.map